import {
	Component,
	IComponentBindings,
	IIndexFieldValue,
	Initialization,
	QueryStateModel
} from "coveo-search-ui";
import * as $ from "jquery";
import * as _ from "underscore";

export class SearchAssistFilters extends Component {
	static ID = 'SearchAssistFilters';
	private template: any;
	public urlHashId: string;
	public title: string;
	public field: string;

	constructor(public element: HTMLElement, public bindings: IComponentBindings) {
		super(element, SearchAssistFilters.ID, bindings);
		this.field = this.element.getAttribute("data-coveo-field");
		this.title = this.element.getAttribute("data-title");
		this.template = _.template($("script.result-template", this.element).html().trim());
		this.urlHashId = QueryStateModel.getFacetId(this.element.getAttribute("data-field"));
		this.fetchFacetValues().then((facetValues) => this.buildDom(facetValues));
	}

	public buildDom(facetValues: IIndexFieldValue[]) {
		facetValues.forEach((facet) => {
			var value = facet.value,
				id = value.replace(/\s+/g, ""),
				html = this.template({value: value, id: id});

			$(this.element).append(html);
		});
	}

	protected getSelectedElements() {
		return $("input[type='checkbox']:checked", this.element).get();
	}

	public getUriEncodedSelectedValues(): string[] {
		return this.getSelectedElements().map((el) => encodeURIComponent(el.getAttribute("id")));
	}

	private fetchFacetValues() {
		var endpoint = Coveo.SearchEndpoint.endpoints['default'];
		return endpoint.listFieldValues({ field: this.field, maximumNumberOfValues: 100, sortCriteria : "nosort" });
	}
}

Initialization.registerAutoCreateComponent(SearchAssistFilters);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SearchAssistFilters.ts